import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import {
  getPayroll,
  postPayroll,
  editPayroll,
  payrollTemplate,
  importPayroll,
  exportPayroll,
  deletePayroll,
  getCompanyStatus,
  getCompanyType,
  getCompanyCategory,
  multiAreasTemplate,
  multiAreassimport,
  multiAttributesTemplate,
  multiAttributesimport,
  getEmployee,
  filterEmployee,
  getEmployeebyId,
  postEmployee,
  editEmployees,
  getFieldName,
  deleteEmployees,
  exportEmployee,
  getEmployeesTemplate,
  importEmployees,
  getAreas,
  postAreas,
  editAreas,
  deleteAreas,
  exportAreas,
  getAreasTemplate,
  importAreas,
  postLoginInfoemployee,
  postAttributes,
  resetPasswordEmployee,
  toggleUserstatus,
  generatePassword,
  getEmployeeJobtitle,
  verifyEmployeeNationality,
  importEmployeeDocument,
  getPendingVerifications
} from '../../services/Employees/Employee_services';
const initialValues = {
  statusList: [],
  companyList: [],
  categoryList: [],
  payrollList: [],
};
let employeeStore = (set) => ({
  ...initialValues,
  multiAreasTemplate: async () => {
    const response = await multiAreasTemplate();
    return response;
  },
  multiAreassimport: async (params) => {
    const response = await multiAreassimport(params);
    return response;
  },
  multiAttributesTemplate: async () => {
    const response = await multiAttributesTemplate();
    return response;
  },
  multiAttributesimport: async (params) => {
    const response = await multiAttributesimport(params);
    return response;
  },
  getPayroll: async (params) => {
    const response = await getPayroll(params);
    set({ payrollList: response });
    return response;
  },
  setPayrollList: (data) => set({ payrollList: data }),
  postPayroll: async (params) => {
    const response = await postPayroll(params);
    return response;
  },
  editPayroll: async (params, data) => {
    const response = await editPayroll(params, data);
    return response;
  },
  payrollTemplate: async () => {
    const response = await payrollTemplate();
    return response;
  },
  importPayroll: async (params) => {
    const response = await importPayroll(params);
    return response;
  },
  exportPayroll: async (params) => {
    const response = await exportPayroll(params);
    return response;
  },
  deletePayroll: async (params) => {
    const response = await deletePayroll(params);
    return response;
  },
  getCompanyStatus: async (params) => {
    const response = await getCompanyStatus(params);
    set({ statusList: response });
    return response;
  },
  getCompanyType: async () => {
    const response = await getCompanyType();
    set({ companyList: response });
    return response;
  },
  getCompanyCategory: async () => {
    const response = await getCompanyCategory();
    set({ categoryList: response });
    return response;
  },
   getEmployee: async (params) => {
      const response = await getEmployee(params);
      set({ employeeData: response });
      return response;
    },
    filterEmployee: async (params) => {
      const response = await filterEmployee(params);
      return response;
    },
    getEmployeebyId: async (params) => {
      const response = await getEmployeebyId(params);
      return response;
    },
    postEmployee: async (params) => {
      const response = await postEmployee(params);
      return response;
    },
    editEmployees: async (params, data) => {
      const response = await editEmployees(params, data);
      return response;
    },
    getFieldName: async (params, data) => {
      const response = await getFieldName(params, data);
      return response;
    },
    deleteEmployees: async (params) => {
      const response = await deleteEmployees(params);
      return response;
    },
    exportEmployee: async (params) => {
      const response = await exportEmployee(params);
      return response;
    },
    importEmployees: async (params) => {
      const response = await importEmployees(params);
      return response;
    },
    getEmployeesTemplate: async (params) => {
      const response = await getEmployeesTemplate(params);
      return response;
    },
    getAreas: async (params, params1) => {
      const response = await getAreas(params, params1);
      return response;
    },
    postAreas: async (params, data) => {
      const response = await postAreas(params, data);
      return response;
    },
    editAreas: async (params, params2, data) => {
      const response = await editAreas(params, params2, data);
      return response;
    },
    deleteAreas: async (params) => {
      const response = await deleteAreas(params);
      return response;
    },
    exportAreas: async (params, params2) => {
      const response = await exportAreas(params, params2);
      return response;
    },
    getAreasTemplate: async (params) => {
      const response = await getAreasTemplate(params);
      return response;
    },
    importAreas: async (params, data) => {
      const response = await importAreas(params, data);
      return response;
    },
    postLoginInfoemployee: async (params,data) => {
      const response = await postLoginInfoemployee(params,data);
      return response;
    },
    postAttributes: async (data) => {
      const response = await postAttributes(data);
      return response;
    },
    resetPasswordEmployee: async (params) => {
      const response = await resetPasswordEmployee(params);
      return response;
    },
    toggleUserstatus: async (params, params2) => {
      const response = await toggleUserstatus(params, params2);
      return response;
    },
    generatePassword: async () => {
      const response = await generatePassword();
      return response;
    },
     getEmployeeJobtitle: async (params) => {
      const response = await getEmployeeJobtitle(params);
      return response;
    },
      verifyEmployeeNationality: async (params,data) => {
      const response = await verifyEmployeeNationality(params,data);
      return response;
    },
      importEmployeeDocument: async (params,data) => {
      const response = await importEmployeeDocument(params,data);
      return response;
    },
      getPendingVerifications: async (params) => {
      const response = await getPendingVerifications(params);
      return response;
    },
});

employeeStore = devtools(employeeStore);

export const useEmployeeStore = create(employeeStore);
